import styled, { css } from 'styled-components'

const OverlayModifiers = {
  active: () => css`
    opacity: 1;
  `,
  close: () => css`
    opacity: 0;
    pointer-events: none;
  `
}

export const Overlay = styled.div`
  ${({ theme, active }) => css`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
    transition: opacity ${theme.transition.default};

    ${active && OverlayModifiers.active()}
    ${!active && OverlayModifiers.close()}
  `}
`

export const HeaderModal = styled.div`
  ${({ theme, active }) => css`
    display: ${active ? 'block' : 'none'};
    transition: all 400ms;
    position: absolute;
    left: 0;

    z-index: 5;

    &.header-modal-cart {
      left: initial;
      right: 0;
    }

    @media (max-width: 1600px) {
      &.header-modal-local {
        left: initial;
        right: 0;
      }
    }

    @media (max-width: 1360px) {
      &.header-modal-cart {
        left: initial;
        right: 0;
        min-width: 355px;
      }
    }

    @media (max-width: ${theme.media.ipad}) {
      &.header-modal-local {
        width: 100%;
      }
    }
  `}
`

export const Wrapper = styled(HeaderModal)`
  width: 220px;
`

export const ModalList = styled.ul`
  hr {
    opacity: 0.3;
    margin-top: -4px;
    margin-bottom: 10px;
  }
`

export const ModalListItem = styled.li`
  ${({ theme }) => css`
    list-style-type: none;
    margin-bottom: 12px;

    a {
      font-size: 14px;
      transition: all 400ms;

      &:hover {
        color: ${theme.colors.primary};
      }
    }

    /* &:last-child {
      padding-top: 20px;
      border-top: 1px solid #bbbbbb;
      font-weight: bold;
      margin-bottom: 0px;
    } */
  `}
`
